module.exports = __webpack_public_path__ + "static/kranDaten03-9fa3d06812dc5b6ac4c96657a7b01c71.jpg";